﻿import { useState } from 'react'
import { Calendar, Crown } from 'lucide-react'
import TodayLeaderboard from '@/components/leaderboard/TodayLeaderboard'
import TotalLeaderboard from '@/components/leaderboard/TotalLeaderboard'

type LeaderboardMode = 'today' | 'total'

export default function LeaderboardPage() {
  const [selectedMode, setSelectedMode] = useState<LeaderboardMode>('today')

  const leaderboardModes = [
    { key: 'today' as LeaderboardMode, label: '日榜', icon: Calendar, description: '今日实时排行' },
    { key: 'total' as LeaderboardMode, label: '总榜', icon: Crown, description: '累计总排行' },
  ]

  const renderLeaderboard = () => {
    switch (selectedMode) {
      case 'today':
        return <TodayLeaderboard />
      case 'total':
        return <TotalLeaderboard />
      default:
        return <TodayLeaderboard />
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-50 relative overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 right-10 w-64 h-64 bg-blue-200/30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-32 left-10 w-80 h-80 bg-indigo-200/20 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-purple-100/40 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-md mx-auto px-4 py-6">
        <div className="text-center mb-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">读书排行榜</h1>
          <p className="text-sm text-gray-600">多维度排行，见证阅读成长</p>
        </div>

        <div className="bg-white/80 backdrop-blur-xl border border-gray-200/50 rounded-2xl shadow-xl p-4 mb-4">
          <div className="grid grid-cols-2 gap-3">
            {leaderboardModes.map(({ key, label, icon: Icon }) => (
              <button
                key={key}
                onClick={() => setSelectedMode(key)}
                className={`flex items-center justify-center py-3 px-4 rounded-xl font-medium transition-all duration-300 ${
                  selectedMode === key
                    ? 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-lg'
                    : 'text-gray-700 hover:bg-white/50 backdrop-blur-sm'
                }`}
              >
                <Icon className="h-4 w-4 mr-2" />
                <span className="text-sm">{label}</span>
              </button>
            ))}
          </div>
        </div>

        {renderLeaderboard()}
      </div>
    </div>
  )
}
